import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EmailTemplateService } from 'src/app/shared/services/email-template.service';
import { ModalConfirmationComponent } from 'src/app/shared/components/modal-confirmation/modal-confirmation.component';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { MandrillEmailTemplateType } from '../../models/email-templates/mandrill-email-template-type';
import { AuthService } from 'src/app/auth/auth.service';
import { EmailTemplate } from '../../models/email-templates/emailTemplate';

@Component({
  selector: 'email-template-tile',
  templateUrl: './email-template-tile.component.html',
  styleUrls: ['./email-template-tile.component.scss'],
})
export class EmailTemplateTileComponent {
  @Input() emailTemplate: EmailTemplate;
  @Output() edit = new EventEmitter<EmailTemplate>();
  @Output() clone = new EventEmitter<EmailTemplate>();

  confirmationRef: MatDialogRef<ModalConfirmationComponent>;

  constructor(
    private emailTemplateService: EmailTemplateService,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private authService: AuthService
  ) {}

  public setDefault() {
    this.emailTemplateService.setDefaultTemplate(this.emailTemplate.id);
  }

  public getMandrillEmailTemplateTypeForPreview() {
    return MandrillEmailTemplateType.GenericEmailTemplate;
  }

  public hasOwnerRole(): boolean {
    return this.authService.ownerLevelAccess;
  }

  public delete() {
    if (this.emailTemplate.isDefault) {
      this.snackBar.open(
        'This template cannot be deleted because it is currently a default template. You must set another template as default first.',
        false
      );
      return;
    }

    this.confirmationRef = this.dialog.open(ModalConfirmationComponent, {
      data: { action: `delete ${this.emailTemplate.templateName}`, delete: true },
    });

    this.confirmationRef.afterClosed().subscribe((result) => {
      if (result) {
        this.emailTemplateService.deleteTemplate(this.emailTemplate.id);
      }
      this.confirmationRef = null;
    });
  }

  public onEdit() {
    this.edit.emit(this.emailTemplate);
  }

  public onClone() {
    this.clone.emit(this.emailTemplate);
  }
}
